import { useSelector, useDispatch, TypedUseSelectorHook } from 'react-redux';
import {
  legacy_createStore as createStore,
  compose,
  combineReducers,
  applyMiddleware,
  Dispatch
} from 'redux';
import { globalReducer } from './global.slice';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const rootReducer = combineReducers({
  global: globalReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = ({ initialData = {} } = {}) =>
  createStore(rootReducer, initialData, composeEnhancers(applyMiddleware()));

export type RootState = ReturnType<typeof rootReducer>;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<Dispatch>();
